/* 🤖 this file was generated by svg-to-ts */
export const matIconArrowForwardIos: {
  name: 'arrow-forward-ios';
  data: string;
} = {
  name: 'arrow-forward-ios',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z"/></svg>`
};
